<template>
  <q-page class="error">
    <div class="row justify-center items-center q-pa-md q-mt-xl">
      <q-card class="col-12 col-md-8">
        <q-card-section class="q-pa-lg">
          <h1 class="heading-2 q-mb-lg">{{ title }}</h1>
          <p>{{ message }}</p>
          <common-link :href="$route('homepage')" label="Terug naar de homepage" icon="arrow_back"/>
        </q-card-section>
      </q-card>
    </div>
  </q-page>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Onbekend'
    },
    message: {
      type: String,
      default: 'Onbekend'
    },
  }
}
</script>